import { Route, Routes } from "react-router-dom";
// import Error404 from "@/views/errors/404";
// import { DASHBOARD_PREFIX_PATH } from "@/config";
// import { TopDashboardLayout } from "@/layouts/dashboard-layout/Dashboard";
// import AuthMiddleWare from "@/middlewares/authMiddleWare";
// import GuestMiddleWare from "@/middlewares/guestMiddleWare";
import HomeLayout from "../layout/HomeLayout";
import { AUTH_PRFIX, DASHBOARD_PRFIX } from "../config";
import AuthLayout from "../layout/AuthLayout";
import DashboardLayout from "../layout/DashboardLayout";
import GuestMiddleware from "../middlewares/Guest";
import AuthMiddleware from "../middlewares/Auth";

const Views = () => {

  return (
    <>
        <Routes>
          <Route
            path="/*"
            element={<HomeLayout />}
          />
          <Route
            element={
              <GuestMiddleware />
            }
          >
            <Route
              path={`${AUTH_PRFIX}/*`}
              element={<AuthLayout />}
            />
          </Route>
          <Route
            element={
              <AuthMiddleware />
            }
          >
            <Route
              path={`${DASHBOARD_PRFIX}/*`}
              element={
                <DashboardLayout />
              }
            />
          </Route>
          {/* <Route path="*" element={<Error404 title="Page not found" />} /> */}
        </Routes>
    </>
  );
};


export default Views;
